<div class="relative w-full overflow-hidden">
  <!-- Slider container -->
  <div class="relative h-[500px] overflow-hidden">
    <!-- Slides -->
    <div class="flex transition-opacity duration-1000 ease-in-out" #slideContainer>
      <!-- Slide 1 -->
       @for(image of sliderImages; track image) {
        <div class="w-full flex-shrink-0 relative">
          <img [src]="apiBaseImages + image.Enlace" [alt]="image['Nombre De La Imagen']" class="w-full h-[500px] object-cover">
          <div class="absolute inset-0 bg-black/40"></div> <!-- Backdrop overlay -->
        </div>
       }


    </div>

    <!-- Text Overlay -->
    <!-- <div class="absolute top-0 left-0 h-full w-full sm:w-1/2 md:w-auto flex items-center z-10">
      <div class="ms-5 sm:ms-80 md:ms-30">
        <h2 class="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight flex flex-col gap-4">
          <div class="split-text" #splitText>Hazlo hoy,</div>
          <div class="split-text" #splitText>Hazlo fácil</div>
          <div class="subito-text" #subitoBlock>
            <span class="char-special">¡</span>
            <span class="char-special">H</span>
            <span class="char-special">a</span>
            <span class="char-special">z</span>
            <span class="char-special">l</span>
            <span class="char-special">o</span>
            <span class="char-special">&nbsp;</span>
            <span class="char-special">S</span>
            <span class="char-special">ú</span>
            <span class="char-special">b</span>
            <span class="char-special">i</span>
            <span class="char-special">t</span>
            <span class="char-special">o</span>
            <span class="char-special">!</span>
          </div>
        </h2>
        <p class="text-gray-200 mb-6 font-bold flex items-center shine-text">Todo lo encuentras en Súbito</p>
      </div>
    </div> -->


  </div>
</div>
